'use strict';

import React from 'react';

import s from './styles.scss';

export default ({
	recipient,
	title,
	sex,
	skinColor,
	hairColor,
	age,
	weight,
	height,
}) => (
	<div className={ s.data }>
		{ recipient && <div className={ s.dataRow }>
			<label>Recipient:</label>
			<span>{ recipient }</span>
		</div>}
		{ title && <div className={ s.dataRow }>
			<label>Title:</label>
			<span>{ title }</span>
		</div>}
		{ sex && <div className={ s.dataRow }>
			<label>Sex:</label>
			<span className={ s.sex }>{ sex }</span>
		</div>}
		{ skinColor && <div className={ s.dataRow }>
			<label>Skin:</label>
			<span>{ skinColor }</span>
		</div>}
		{ hairColor && <div className={ s.dataRow }>
			<label>Hair:</label>
			<span>{ hairColor }</span>
		</div>}
		{ age && <div className={ s.dataRow }>
			<label>Age:</label>
			<span>{
				Array.isArray(age) ?
					`${ age[0] } – ${ age[1] } yrs` :
					`${ age }`
			}</span>
		</div>}
		{ height && <div className={ s.dataRow }>
			<label>Height:</label>
			<span>{
				Array.isArray(height) ? 
					`${ height[0] } – ${ height[1] } in` :
					`${ Math.floor(height / 12) }' ${ height - 12 * Math.floor(height / 12)}"`
			}</span>
		</div>}
		{ weight && <div className={ s.dataRow }>
			<label>Weight:</label>
			<span>{
				Array.isArray(weight) ? 
					`${ weight[0] } – ${ weight[1] } lbs` :
					`${ weight } lbs`
			}</span>
		</div>}
	</div>
);
